import { IRoute } from "../../../common/helpers/routesMapper";
import { Store } from "redux";
import { seo } from "../../../common/helpers/seo";

import ClosingClassroom from "./closed-classroom";

export default {
    component: ClosingClassroom,
    renderSeo: (store: Store, allMessage: {[key: string]: string}, lang: string) => {
        return seo({ title: "Musicators", allMessage, lang });
    },
} satisfies IRoute;